import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router";
import DataContext from "../Context/DataContext";

function ProtectedRoute() {
  const {token} = useContext(DataContext)
  // const user = window.sessionStorage.getItem('Mobile_No')

  return token  ? <Outlet /> : <Navigate to="/" />;
}

export default ProtectedRoute;
